export enum CommonEventStatusId {
  NotStarted = 1,
  Interrupted = 2,
  Cancelled = 3,
  Delayed = 4,
  Postponed = 5,
  StartDelayed = 6,
  Abandoned = 7,
  Finished = 11,
}
